export default "__VITE_ASSET__d0624463__"